import { render, staticRenderFns } from "./FirstLoginChangePassword.vue?vue&type=template&id=3b3a1e3e&scoped=true"
import script from "./FirstLoginChangePassword.vue?vue&type=script&lang=js"
export * from "./FirstLoginChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a1e3e",
  null
  
)

export default component.exports